module.exports = __webpack_public_path__ + "img/unidade.dd1ba24b.png";